import { useEffect, useState } from 'react'
import { api } from './api'
import type { IrrigationMethod, ProductionType, WaterSource } from './types'

/** The choices a field form offers (GET /orgs/:orgId/field-options). Varieties are suggestions only. */
export type FieldOptions = {
  varieties: string[]
  irrigationMethods: IrrigationMethod[]
  waterSources: WaterSource[]
  productionTypes: ProductionType[]
}

const cache = new Map<string, FieldOptions>()

export function useFieldOptions(orgId: string | undefined): FieldOptions | null {
  const [options, setOptions] = useState<FieldOptions | null>(orgId ? (cache.get(orgId) ?? null) : null)

  useEffect(() => {
    if (!orgId) return
    const cached = cache.get(orgId)
    if (cached) {
      setOptions(cached)
      return
    }
    let cancelled = false
    api
      .get<FieldOptions>(`/orgs/${orgId}/field-options`)
      .then((loaded) => {
        cache.set(orgId, loaded)
        if (!cancelled) setOptions(loaded)
      })
      .catch(() => {
        // The form still works without suggestions; the choices below just stay empty.
      })
    return () => {
      cancelled = true
    }
  }, [orgId])

  return options
}
